var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHospital(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 388,
    y2: 666.719
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efdcfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4428,
    stopColor: "#c1aec7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8a7889"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 340.515,
    y2: 386.458
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f6fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efdcfb"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 97.488,
    y2: 519.957
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 364.032,
    x2: 180.962,
    y1: 221.09,
    y2: 25.346
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efdcfb",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4856,
    stopColor: "#baaad6",
    stopOpacity: 0.486
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679b2"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#65e0db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#27d2f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18cefb"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 214.643,
    x2: 291.323,
    xlinkHref: "#lg2",
    y1: 396.773,
    y2: 499.192
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 278.764,
    x2: 200.825,
    y1: 449.162,
    y2: 422.44
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4a97f6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469bb"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 374.909,
    y2: 273.397
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 252.579,
    x2: 258.916,
    xlinkHref: "#lg2",
    y1: 275.614,
    y2: 365.912
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 7.421,
    y2: 212.062
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f82814"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6245,
    stopColor: "#d22725",
    stopOpacity: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 289.565,
    x2: 151.206,
    xlinkHref: "#lg3",
    y1: 115.016,
    y2: 47.42
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.411,
    x2: 262.917,
    xlinkHref: "#lg3",
    y1: 138.852,
    y2: 30.066
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m479.939 499.154h-449.878c-9.048 0-16.383-7.335-16.383-16.383v-119.735h482.644v119.735c0 9.048-7.335 16.383-16.383 16.383z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m492.02 384.385h-474.04c-9.93 0-17.98-8.05-17.98-17.98v-8.953c0-9.93 8.05-17.98 17.98-17.98h474.04c9.93 0 17.98 8.05 17.98 17.98v8.953c0 9.931-8.05 17.98-17.98 17.98z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m396.957 499.154h-283.914v-374.651c0-11.015 8.929-19.944 19.944-19.944h244.027c11.014 0 19.944 8.929 19.944 19.944v374.651z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m396.96 124.505v254.041l-231.133-231.144c-3.749-1.489-6.4-5.133-6.4-9.411v-33.428h217.582c11.016.001 19.951 8.926 19.951 19.942z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m302.097 499.154h-94.195v-94.183c0-4.599 3.728-8.327 8.327-8.327h77.542c4.599 0 8.327 3.728 8.327 8.327v94.183z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m293.771 396.645h-38.771v102.509h47.097v-94.183c0-4.598-3.728-8.326-8.326-8.326z",
    fill: "url(#SVGID_6_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m366.729 350.334h-223.458c-3.022 0-5.471-2.449-5.471-5.471v-69.508c0-3.022 2.449-5.471 5.471-5.471h223.457c3.022 0 5.471 2.449 5.471 5.471v69.508c.001 3.021-2.449 5.471-5.47 5.471z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.651 340.013h-203.302c-2.479 0-4.489-2.01-4.489-4.489v-50.83c0-2.479 2.01-4.489 4.489-4.489h203.302c2.479 0 4.489 2.01 4.489 4.489v50.83c0 2.479-2.01 4.489-4.489 4.489z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m340.429 64.701h-43.715v-43.714c0-5.6-4.54-10.141-10.14-10.141h-63.147c-5.6 0-10.14 4.54-10.14 10.141v43.715h-43.715c-5.6 0-10.141 4.54-10.141 10.141v63.147c0 5.6 4.54 10.141 10.141 10.141h43.715v43.715c0 5.6 4.54 10.141 10.14 10.141h63.147c5.6 0 10.14-4.54 10.14-10.141v-43.715h43.715c5.6 0 10.14-4.54 10.14-10.141v-63.148c0-5.601-4.54-10.141-10.14-10.141z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m340.429 64.701h-43.715v-43.714c0-5.6-4.54-10.141-10.14-10.141h-31.574v191.139h31.574c5.6 0 10.14-4.54 10.14-10.141v-43.715h43.715c5.6 0 10.14-4.54 10.14-10.141v-63.146c0-5.601-4.54-10.141-10.14-10.141z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m159.431 102.901v35.088c0 5.6 4.54 10.141 10.141 10.141h43.715v43.715c0 5.6 4.54 10.141 10.14 10.141h63.147c5.6 0 10.14-4.54 10.14-10.141v-43.715h43.715c5.6 0 10.14-4.54 10.14-10.141v-35.088z",
    fill: "url(#SVGID_11_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHospital);
export default __webpack_public_path__ + "static/media/icon-hospital.18431caffc65bd51c005237642947495.svg";
export { ForwardRef as ReactComponent };